export interface AssistantMessage {
  emoji: string
  text: string
}

export interface StepMessages {
  greeting: string
  messages: AssistantMessage[]
}

export const signupAssistantMessages: Record<number, StepMessages> = {
  0: {
    greeting: '👋 ¡Hola! Soy tu asistente de registro.',
    messages: [
      {
        emoji: '📝',
        text: 'Completa tu nombre y apellido tal como aparecen en tus documentos.',
      },
      {
        emoji: '📱',
        text: 'Tu teléfono debe ser chileno con formato +569XXXXXXXX (12 dígitos en total).',
      },
      {
        emoji: '📧',
        text: 'Usa un correo electrónico válido. Te enviaremos un email de verificación.',
      },
      {
        emoji: '🔒',
        text: 'Tu contraseña debe tener mínimo 8 caracteres, al menos 1 mayúscula y 1 minúscula.',
      },
    ],
  },
  1: {
    greeting: '🏢 ¡Genial! Ahora configuremos tu organización.',
    messages: [
      {
        emoji: '✏️',
        text: 'El nombre de la organización es un espacio donde puedes agrupar una o mas empresas.',
      },
      {
        emoji: '👤',
        text: 'Selecciona tu tipo de usuario según tu perfil:',
      },
      {
        emoji: '📊',
        text: 'Contador: si gestionas varias empresas y necesitas reportes rápidos.',
      },
      {
        emoji: '🏭',
        text: 'Socio / Empresa: si administras tu propia empresa y quieres control financiero.',
      },
    ],
  },
  2: {
    greeting: '🔗 ¡Casi listo! Conectemos tu empresa con el SII.',
    messages: [
      {
        emoji: '⚠️',
        text: 'Importante: usa el RUT de la empresa, NO tu RUT personal.',
      },
      {
        emoji: '🔑',
        text: 'La clave que debes usar es tu clave tributaria del SII (NO la ClaveÚnica).',
      },
      {
        emoji: '📄',
        text: 'Formato del RUT: 12345678-9 (incluye el guión y el dígito verificador).',
      },
      {
        emoji: '🔐',
        text: 'No te preocupes, tu clave se encripta antes de enviarse. Tus datos están seguros.',
      },
    ],
  },
  3: {
    greeting: '📬 ¡Ya casi terminamos! Solo falta verificar tu correo.',
    messages: [
      {
        emoji: '📩',
        text: 'Revisa tu bandeja de entrada, te enviamos un correo de verificación.',
      },
      {
        emoji: '⏳',
        text: 'Estamos verificando tu correo automáticamente. No necesitas hacer nada más aquí.',
      },
      {
        emoji: '🔄',
        text: 'Si no recibiste el email, espera 2 minutos antes de reenviarlo.',
      },
      {
        emoji: '📁',
        text: 'Revisa también tu carpeta de spam o correo no deseado.',
      },
      {
        emoji: '💡',
        text: 'Puedes verificar tu correo desde otro dispositivo o pestaña, lo detectaremos automáticamente.',
      },
    ],
  },
}
